import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Lead-capture form state for the free 15-min session page.
 *
 * The hook owns the form fields, the "sent" flag and the submit handler.
 * It expects two i18n strings for user-facing errors so messages stay
 * localized (passing them in keeps the hook framework-agnostic).
 */
export const useContactForm = ({
  interest = "Sesión gratuita 15 min",
  fallbackMessage = "Solicito sesión gratuita de 15 minutos.",
  errorMissing,
  errorSend,
  successMsg,
} = {}) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (k) => (e) => setForm((prev) => ({ ...prev, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      if (errorMissing) toast.error(errorMissing);
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, {
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        interest,
        message: form.message || fallbackMessage,
      });
      setSent(true);
      if (successMsg) toast.success(successMsg);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      if (errorSend) toast.error(errorSend);
    } finally {
      setLoading(false);
    }
  };

  return { form, update, submit, loading, sent };
};

export default useContactForm;
